import { useQuery } from '@tanstack/react-query';
import type { SourcePageCopyResponse } from '@brand24-original/llm-types';
import { getSourcePageCopy } from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';

const GET_SOURCE_PAGE_COPY = 'GET_SOURCE_PAGE_COPY';

/** Loaded only while the copy dialog is open (`enabled`) — the text can be hundreds of KB. */
export const useGetSourcePageCopy = (projectId: number | null, source: string, enabled: boolean) => {
  const queryEnabled = enabled && !!projectId && !!source;

  const { data, isLoading, isError } = useQuery<SourcePageCopyResponse>({
    queryKey: [GET_SOURCE_PAGE_COPY, projectId, source],
    queryFn: () => getSourcePageCopy(projectId!, source),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    pageCopy: queryEnabled ? data?.copy ?? null : null,
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
  };
};
